var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-row', {
    staticClass: "px-4"
  }, [_vm.contigenciaSVCAN ? _c('div', {
    staticClass: "card card-custom bg-light-warning card-stretch gutter-b p-4"
  }, [_c('p', {
    staticClass: "mb-0 font-weight-bolder"
  }, [_c('Warning', {
    attrs: {
      "size": 20
    }
  }), _vm._v(" Operações de Nota Fiscal Eletrônica sendo realizadas em ambiente de Contigência ")], 1)]) : _vm._e()]), _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Natureza",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 0;
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Natureza",
      "label-for": "natureza"
    }
  }, [_c('VueSelect', {
    ref: "buscarNatureza",
    class: {
      hasErrors: _vm.naturezaError
    },
    attrs: {
      "id": "naturezaWarning",
      "filterable": false,
      "options": _vm.naturezas,
      "state": _vm.validateState('natureza')
    },
    on: {
      "input": _vm.setNatureza,
      "search": _vm.onSearchNatureza
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " - " + _vm._s(option.cfop.codigo) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.natureza,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "natureza", $$v);
      },
      expression: "form.natureza"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código da Natureza ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CFOP",
      "label-for": "cfop"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "cfop",
      "name": "cfop"
    },
    model: {
      value: _vm.form.cfop,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cfop", $$v);
      },
      expression: "form.cfop"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "serie",
      "label-for": "serie",
      "label": "Série"
    }
  }, [_c('VueSelect', {
    ref: "buscarserie",
    attrs: {
      "filterable": false,
      "options": _vm.series
    },
    on: {
      "input": _vm.setSerie
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.serie) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.serie,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "serie", $$v);
      },
      expression: "form.serie"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a serie ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "finalidade",
      "label-for": "finalidade",
      "label": "Finalidade da NF-e"
    }
  }, [_c('VueSelect', {
    ref: "buscarFinalidade",
    class: {
      hasErrors: _vm.finalidadeError
    },
    attrs: {
      "state": _vm.validateState('finalidade'),
      "filterable": false,
      "options": _vm.finalidades
    },
    on: {
      "input": _vm.setFinalidade
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.finalidade,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "finalidade", $$v);
      },
      expression: "form.finalidade"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a finalidade ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vendedor",
      "label-for": "vendedor"
    }
  }, [_c('VueSelect', {
    ref: "buscaVendedor",
    attrs: {
      "filterable": false,
      "options": _vm.vendedores
    },
    on: {
      "input": _vm.setVendedor,
      "open": _vm.onSearchVendedor,
      "search": _vm.onSearchVendedor
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.vendedor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vendedor", $$v);
      },
      expression: "form.vendedor"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do vendedor ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_vm.isDevolution ? _c('b-form-group', {
    attrs: {
      "label": "Chave da NF-e",
      "label-for": "chave-nfe"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "keyDevolution",
      "name": "keyDevolution",
      "type": "number",
      "formatter": _vm.formatKeyDevolution
    },
    model: {
      value: _vm.form.keyDevolution,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "keyDevolution", $$v);
      },
      expression: "form.keyDevolution"
    }
  })], 1) : _vm._e()], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataEmissao",
      "label-for": "dataEmissao",
      "label": "Data Emissão"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "state": _vm.validateState('dataEmissao'),
      "reset-button": "",
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.dataEmissao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataEmissao", $$v);
      },
      expression: "form.dataEmissao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataSaida",
      "label-for": "dataSaida",
      "label": "Data Saída"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "reset-button": "",
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.dataSaida,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataSaida", $$v);
      },
      expression: "form.dataSaida"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "horaSaida",
      "label-for": "horaSaida",
      "label": "Hora Saída"
    }
  }, [_c('b-form-timepicker', {
    attrs: {
      "locale": "pt-br",
      "reset-button": ""
    },
    model: {
      value: _vm.form.horaSaida,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "horaSaida", $$v);
      },
      expression: "form.horaSaida"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };